<template>
  <div class="flex flex-row">
    <div class="relative z-100 w-full">
      <div class="h-full">
        <mq-layout
          mq="tablet+"
          class="flex flex-col items-center w-24 h-full bg-grey-darkest"
        >
          <a href="/#/vaults">
            <img
              :src="'/images/sidenav/' + vault_type + '-sidelogo.png'"
              alt
              class="my-8"
            />
          </a>
        </mq-layout>
      </div>
    </div>

    <sweet-modal icon="warning" ref="not_available" overlay-theme="dark"
      >This feature is not yet available</sweet-modal
    >

    <sweet-modal
      overlay-theme="dark"
      hide-close-button
      blocking
      enable-mobile-fullscreen
      ref="t_and_c"
      :width="$mq == 'mobile' ? '100%' : '50%'"
    >
      <div class="clearfix">
        <p class="text-brand text-4xl">Terms and Conditions</p>
        <p class="font-semibold text-black">
          To use {{ vault_name }}, you must read and agree to the terms and
          conditions.
        </p>
        <div
          class="
            border border-grey
            overflow-y-scroll
            text-left
            p-3
            content
            my-2
          "
        >
          <terms-and-conditions></terms-and-conditions>
        </div>
        <div class="flex justify-between" v-if="!processing_t_and_c">
          <button
            class="px-4 py-3 font-medium bg-grey text-white rounded"
            @click.prevent="
              $refs.t_and_c.close();
              cancelTermsAndConditions();
            "
          >
            <i class="fa fa-times"></i> Cancel
          </button>

          <button
            class="
              px-4
              py-3
              font-medium
              bg-white
              text-black
              rounded
              border
              hover:bg-grey-lighter
            "
            @click.prevent="download"
          >
            <i class="fa fa-download text-brand"></i> Download T&amp;Cs
          </button>

          <button
            class="px-4 py-3 font-medium bg-brand text-white rounded"
            @click.prevent="acceptTermsAndConditions()"
          >
            <i class="fa fa-check"></i> I agree
          </button>
        </div>
        <div v-else class="text-center">
          <p class="bg-grey-ligthest p-4">
            <i class="fa fa-spin fa-spinner"></i> Please wait...
          </p>
        </div>
      </div>
      <div class="h-48 lg:h-auto"></div>
    </sweet-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TermsAndConditions from "./TermsAndConditions";

export default {
  components: {
    TermsAndConditions,
  },

  props: {
    static: {
      default() {
        return false;
      },
    },
    showGlobalLink: {
      default() {
        return true;
      },
    },
  },

  data() {
    return {
      processing_t_and_c: false,
    };
  },

  methods: {
    acceptTermsAndConditions() {
      this.processing_t_and_c = true;
      axios.patch("/api/users/accept-tc").then(({ data }) => {
        if (data.success) {
          this.processing_t_and_c = false;
          this.$refs.t_and_c.close();
        }
      });
    },

    cancelTermsAndConditions() {
      this.processing_t_and_c = false;
      axios.post("/api/logout").then(({ data }) => {
        window.location.href = "/auth-login";
      });
    },

    download() {
      axios
        .get("/download-t-and-c", { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Terms and Conditions.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },

    vault_name() {
      return _.startCase(window.vault_type) + "Vault";
    },
  },

  computed: {
    vault_type() {
      return window.vault_type;
    },
  },
};
</script>

<style>
.bg-vault-count {
  background: url("/images/sidenav/icn_vaults_grey.png") no-repeat;
  background-size: contain;
}
.hamburger-button {
  width: 40px !important;
}
.content {
  height: 380px;
}
.clearfix {
  clear: both;
}
</style>
